export interface RegionalUrl {
  serviceBaseUrl: string | null;
  region: string | null;
  setRegionByBaseUrl: (region: string) => void;
  setServiceBaseUrl: (serviceBaseUrl: string) => void;
}

/**
 * This function gets and sets the service URL for querying
 * via the ApolloClient. It stores the value for the base
 * url in the sessionStorage property called `user.serviceBaseUrl`
 * for it to be retrievable on refresh.
 * @returns object
 */
export const getRegionalEndpoint = (): RegionalUrl => {
  const setRegionByBaseUrl = (region: string) => {
    if (!sessionStorage.getItem("user.region")) {
      sessionStorage.setItem("user.region", region);
    }
  }

  const setServiceBaseUrl = (url: string) => {
    if (!sessionStorage.getItem("user.serviceBaseUrl")) {
      sessionStorage.setItem("user.serviceBaseUrl", url);
    }
  };

  return {
    serviceBaseUrl: sessionStorage.getItem("user.serviceBaseUrl"),
    region: sessionStorage.getItem("user.region"),
    setRegionByBaseUrl,
    setServiceBaseUrl,
  };
};
